"use client";

import { useMemo } from "react";

import type { BuilderBlock, BuilderContextInterface, RegisteredComponents } from "@builder.io/sdk-react";
import { Blocks, isPreviewing } from "@builder.io/sdk-react";

import { Container } from "@jti/core-components/components/Container";
import { ImageGallery as ImageGalleryUI } from "@jti/ui/components/ImageGallery";

import { ImageGalleryTopicSchema } from "./schema";

interface ImageGalleryProps {
  builderBlock: BuilderBlock;
  builderContext: BuilderContextInterface;
  builderComponents: RegisteredComponents;
  attributes: Record<string, string>;
}

export function ImageGallery({ builderBlock, builderContext, builderComponents }: ImageGalleryProps) {
  const childBlocks = useMemo(() => builderBlock?.children ?? [], [builderBlock?.children]);

  const convertedData = useMemo(
    () =>
      childBlocks
        .filter((block) => block?.component?.name === "ImageGalleryTopic")
        .map((block) => {
          try {
            const imageGalleryData = block?.component?.options?.data;
            const validatedImageGalleryData = ImageGalleryTopicSchema.parse(imageGalleryData);
            return { ...validatedImageGalleryData };
          } catch (error) {
            console.error("Image Gallery validation failed", error);
            return null;
          }
        })
        .filter((data): data is NonNullable<typeof data> => data !== null),
    [childBlocks]
  );

  if (isPreviewing()) {
    return (
      <div>
        <Container>
          <h1>Add ImageGalleryTopics</h1>
          <Blocks
            blocks={childBlocks}
            parent={builderBlock?.id}
            path="children"
            context={builderContext}
            registeredComponents={builderComponents}
          />
        </Container>
      </div>
    );
  }

  return <ImageGalleryUI data={convertedData} />;
}
